export default {
  // 按鈕文本
  historyList: "歷史列表",
  keyStep: "關鍵步驟",

  // 標題
  keyStepTitle: "關鍵步驟",
  historyListTitle: "歷史列表",
};
